<div class="col-lg-12 content-scroll-screen parent">
  <div class="row child">
    <p-card class="card-spacing-0">
      <span class="d-flex justify-content-between align-items-center m-3">
        <span class="col-auto">
          <h2 class="mb-0">Multi Ledger</h2>
        </span>
        <span class="d-flex gap-2 customizefilter-btn"> </span>
      </span>
      <div class="row m-3">
        <div class="col-12 d-flex align-items-center gap-4">
          <div class="col">
            <div class="form-group has-float-label">
              <label class="form-label" for="selectedAssociatedBc"
                >Multi Ledger Linked BC</label
              >
              <p-select
                [(ngModel)]="selectedBc"
                (onChange)="getMultiLedgerAssociations()"
                [options]="bcList"
                optionLabel="fullName"
                optionValue="personnelNumber"
                [showClear]="true"
                [filter]="true">
                <ng-template let-item #item>
                  {{
                    item.firstName +
                      " " +
                      item.lastName +
                      " " +
                      "(" +
                      item.personnelNumber +
                      ")"
                  }}
                </ng-template>
              </p-select>
            </div>
          </div>
          <div class="col">
            <div class="form-group has-float-label">
              <label class="form-label" for="selectedAssociatedBc"
                >Multi Ledger Linked BC</label
              >
              <p-select
                [(ngModel)]="selectedAssociatedBc"
                [options]="availableAssociatedBcList"
                optionLabel="fullName"
                optionValue="personnelNumber"
                [showClear]="true"
                [filter]="true">
                <ng-template let-item #item>
                  {{
                    item.firstName +
                      " " +
                      item.lastName +
                      " " +
                      "(" +
                      item.personnelNumber +
                      ")"
                  }}
                </ng-template>
              </p-select>
            </div>
          </div>
          <div class="col-auto d-flex align-items-bottom mt-4">
            <p-button label="Add" (click)="addMultiLedgerAssociation()" />
          </div>
        </div>
      </div>
      <div class="col-12">
        <div class="d-flex justify-content-between m-3">
          <div>
            <h3 class="mb-0">
              <ng-container>Associations</ng-container>
            </h3>
          </div>
          <div class="samplepo-panel ml-auto d-flex justify-content-between">
            <div
              class="ms-3 nav-link p-0 d-flex align-items-center"
              *ngIf="selectedAssociations && selectedAssociations.length">
              <i class="icon-Delete me-2"></i>
              <a
                class="link text-decoration-none delcol"
                (click)="deleteMultiLedgerAssociation()"
                ><i class="pi pi-trash"></i> Delete</a
              >
            </div>
          </div>
        </div>
      </div>
      <div class="col-12">
        <p-table
          #dt
          responsiveLayout="scroll"
          [value]="associations"
          [(selection)]="selectedAssociations"
          styleClass="p-datatable-customers no-overfollow ordersLineItems no-wrap table-hover-bg"
          [rowHover]="true"
          [rows]="20"
          [showCurrentPageReport]="true"
          [paginator]="false"
          [filterDelay]="0"
          selectionMode="multiple"
          styleClass="table-listing">
          <ng-template pTemplate="header">
            <tr class="table-head">
              <th></th>
              <th class="number">Personal #</th>
              <th class="status">Name</th>
              <th class="name">Phone</th>
              <th class="name">Email</th>
            </tr>
            <tr *ngIf="associations && associations.length">
              <th></th>
              <th>
                <div class="d-flex">
                  <input
                    jniAutoCompleteBlocker
                    pInputText
                    type="text"
                    name="associatedBCPersonnelNumber"
                    id="associatedBCPersonnelNumber"
                    (input)="
                      dt.filter(
                        $any($event.target).value,
                        'associatedBCPersonnelNumber',
                        'contains'
                      )
                    "
                    placeholder=""
                    class="p-column-filter p-inputtext p-component" />
                </div>
              </th>
              <th>
                <div class="d-flex">
                  <input
                    jniAutoCompleteBlocker
                    pInputText
                    type="text"
                    name="name"
                    id="name"
                    (input)="
                      dt.filter($any($event.target).value, 'name', 'contains')
                    "
                    placeholder=""
                    class="p-column-filter p-inputtext p-component" />
                </div>
              </th>
              <th>
                <div class="d-flex">
                  <input
                    jniAutoCompleteBlocker
                    pInputText
                    type="text"
                    name="phone"
                    id="phone"
                    (input)="
                      dt.filter($any($event.target).value, 'phone', 'contains')
                    "
                    placeholder=""
                    class="p-column-filter p-inputtext p-component" />
                </div>
              </th>
              <th>
                <div class="d-flex">
                  <input
                    jniAutoCompleteBlocker
                    pInputText
                    type="text"
                    name="email"
                    id="email"
                    (input)="
                      dt.filter($any($event.target).value, 'email', 'contains')
                    "
                    placeholder=""
                    class="p-column-filter p-inputtext p-component" />
                </div>
              </th>
            </tr>
          </ng-template>
          <ng-template
            pTemplate="body"
            let-associations
            let-rowIndex="rowIndex">
            <tr
              class="p-selectable-row"
              [pSelectableRow]="associations"
              [pSelectableRowIndex]="rowIndex">
              <td class="col-center">
                <p-tableCheckbox
                  class=""
                  [value]="associations"
                  [pSelectableRow]="associations"></p-tableCheckbox>
              </td>
              <td>{{ associations.associatedBCPersonnelNumber }}</td>
              <td>{{ associations.name }}</td>
              <td>{{ associations.phone }}</td>
              <td>{{ associations.email }}</td>
            </tr>
          </ng-template>
          <ng-template pTemplate="emptymessage">
            <tr>
              <td colspan="30">No Associations Found.</td>
            </tr>
          </ng-template>
        </p-table>
      </div>
    </p-card>
  </div>
</div>
